import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../App';

function Verifications() {
  const [helpers, setHelpers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('pending');
  const [selectedHelper, setSelectedHelper] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadHelpers();
  }, [filter]);

  const loadHelpers = async () => {
    try {
      setLoading(true);
      const params = filter !== 'all' ? `?verification_status=${filter}` : '';
      const response = await api(`/admin/helpers${params}`);
      setHelpers(response.data || []);
    } catch (err) {
      console.error('Failed to load helpers:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (helperId, status) => {
    try {
      await api(`/admin/helpers/${helperId}/verify`, {
        method: 'POST',
        body: JSON.stringify({ status }),
      });
      loadHelpers();
      setShowModal(false);
      setSelectedHelper(null);
    } catch (err) {
      alert('Failed to update verification: ' + err.message);
    }
  };

  const openVerificationModal = (helper) => {
    setSelectedHelper(helper);
    setShowModal(true);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    const colors = {
      pending: '#ffc107',
      approved: '#28a745',
      rejected: '#dc3545'
    };
    return colors[status] || '#666';
  };

  const stats = {
    pending: helpers.filter(h => h.verification_status === 'pending').length,
    approved: helpers.filter(h => h.verification_status === 'approved').length,
    rejected: helpers.filter(h => h.verification_status === 'rejected').length,
  };

  if (loading) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <div style={{
          width: 40, height: 40,
          border: '3px solid #e0e0e0', borderTop: '3px solid #0066cc',
          borderRadius: '50%', animation: 'spin 1s linear infinite',
          margin: '0 auto 16px'
        }} />
        <p style={{ color: '#666' }}>Loading verifications...</p>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>Verifications</h1>
        <p style={{ color: '#666', fontSize: 14 }}>Helper identity verification queue</p>
      </div>

      {/* Stats Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
        <div
          onClick={() => setFilter('pending')}
          style={{
            background: filter === 'pending' ? '#ffc10715' : 'white',
            borderRadius: 12, padding: 20, cursor: 'pointer',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            border: filter === 'pending' ? '2px solid #ffc107' : '2px solid transparent',
            transition: 'all 0.2s'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 48, height: 48, borderRadius: 12, background: '#ffc10715',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24
            }}>⏳</div>
            <div>
              <div style={{ fontSize: 28, fontWeight: 700, color: '#ffc107' }}>{stats.pending}</div>
              <p style={{ fontSize: 13, color: '#666' }}>Pending Review</p>
            </div>
          </div>
        </div>
        <div
          onClick={() => setFilter('approved')}
          style={{
            background: filter === 'approved' ? '#28a74515' : 'white',
            borderRadius: 12, padding: 20, cursor: 'pointer',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            border: filter === 'approved' ? '2px solid #28a745' : '2px solid transparent',
            transition: 'all 0.2s'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 48, height: 48, borderRadius: 12, background: '#28a74515',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24
            }}>✅</div>
            <div>
              <div style={{ fontSize: 28, fontWeight: 700, color: '#28a745' }}>{stats.approved}</div>
              <p style={{ fontSize: 13, color: '#666' }}>Approved</p>
            </div>
          </div>
        </div>
        <div
          onClick={() => setFilter('rejected')}
          style={{
            background: filter === 'rejected' ? '#dc354515' : 'white',
            borderRadius: 12, padding: 20, cursor: 'pointer',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            border: filter === 'rejected' ? '2px solid #dc3545' : '2px solid transparent',
            transition: 'all 0.2s'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 48, height: 48, borderRadius: 12, background: '#dc354515',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24
            }}>❌</div>
            <div>
              <div style={{ fontSize: 28, fontWeight: 700, color: '#dc3545' }}>{stats.rejected}</div>
              <p style={{ fontSize: 13, color: '#666' }}>Rejected</p>
            </div>
          </div>
        </div>
      </div>

      {/* Helpers List */}
      <div style={{ background: 'white', borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>
            {filter === 'pending' ? 'Pending Verifications' : filter === 'approved' ? 'Approved Helpers' : 'Rejected Applications'}
          </h3>
          <button
            onClick={() => setFilter('all')}
            style={{
              padding: '6px 12px', background: filter === 'all' ? '#0066cc' : '#f0f0f0',
              color: filter === 'all' ? 'white' : '#666',
              border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer'
            }}
          >
            Show All
          </button>
        </div>

        {helpers.length > 0 ? (
          <div>
            {helpers.map((helper, idx) => (
              <div
                key={helper.id}
                style={{
                  display: 'flex', alignItems: 'center', padding: '16px 20px',
                  borderBottom: idx < helpers.length - 1 ? '1px solid #eee' : 'none',
                  transition: 'background 0.2s'
                }}
              >
                <div style={{
                  width: 50, height: 50, borderRadius: '50%',
                  background: helper.profile_photo_url ? `url(${helper.profile_photo_url}) center/cover` : '#e0e0e0',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  marginRight: 16, fontSize: 20, color: '#666'
                }}>
                  {!helper.profile_photo_url && (helper.first_name?.[0] || '?')}
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 500, fontSize: 15 }}>
                    {helper.first_name} {helper.last_name}
                  </div>
                  <div style={{ fontSize: 13, color: '#666' }}>{helper.email}</div>
                  <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                    Registered: {formatDate(helper.created_at)}
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                  <div style={{ textAlign: 'right' }}>
                    <span style={{
                      display: 'inline-block', padding: '4px 12px', borderRadius: 20,
                      fontSize: 11, fontWeight: 500,
                      background: `${getStatusColor(helper.verification_status)}15`,
                      color: getStatusColor(helper.verification_status)
                    }}>
                      {helper.verification_status}
                    </span>
                    {helper.verified_at && (
                      <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>
                        {formatDate(helper.verified_at)}
                      </div>
                    )}
                  </div>

                  <div style={{ display: 'flex', gap: 8 }}>
                    <Link
                      to={`/users/${helper.user_id}`}
                      style={{
                        padding: '8px 12px', background: '#f0f0f0', color: '#666',
                        border: 'none', borderRadius: 6, fontSize: 12, textDecoration: 'none'
                      }}
                    >
                      View Profile
                    </Link>
                    {helper.verification_status === 'pending' && (
                      <button
                        onClick={() => openVerificationModal(helper)}
                        style={{
                          padding: '8px 12px', background: '#0066cc', color: 'white',
                          border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer'
                        }}
                      >
                        Review
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ padding: 60, textAlign: 'center', color: '#666' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>
              {filter === 'pending' ? '✨' : filter === 'approved' ? '✅' : '📭'}
            </div>
            <p style={{ fontSize: 16, marginBottom: 8 }}>
              {filter === 'pending' ? 'No pending verifications' : `No ${filter} helpers found`}
            </p>
            <p style={{ fontSize: 13 }}>
              {filter === 'pending' ? 'All verification requests have been processed' : 'Try changing your filter'}
            </p>
          </div>
        )}
      </div>

      {/* Verification Modal */}
      {showModal && selectedHelper && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white', borderRadius: 12, padding: 24, width: 500, maxHeight: '90vh', overflow: 'auto',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
              <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Review Verification</h3>
              <button
                onClick={() => { setShowModal(false); setSelectedHelper(null); }}
                style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#666' }}
              >×</button>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24, padding: 16, background: '#f8f9fa', borderRadius: 8 }}>
              <div style={{
                width: 60, height: 60, borderRadius: '50%',
                background: selectedHelper.profile_photo_url ? `url(${selectedHelper.profile_photo_url}) center/cover` : '#e0e0e0',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 24, color: '#666'
              }}>
                {!selectedHelper.profile_photo_url && (selectedHelper.first_name?.[0] || '?')}
              </div>
              <div>
                <div style={{ fontWeight: 600, fontSize: 16 }}>
                  {selectedHelper.first_name} {selectedHelper.last_name}
                </div>
                <div style={{ fontSize: 14, color: '#666' }}>{selectedHelper.email}</div>
              </div>
            </div>

            {/* Documents */}
            <div style={{ marginBottom: 24 }}>
              <h4 style={{ margin: '0 0 12px 0', fontSize: 14, fontWeight: 600 }}>Submitted Documents</h4>

              {selectedHelper.id_document_url && (
                <div style={{ marginBottom: 12 }}>
                  <p style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>ID Document</p>
                  <a
                    href={selectedHelper.id_document_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: 8,
                      padding: '8px 12px', background: '#f0f0f0', borderRadius: 6,
                      color: '#0066cc', textDecoration: 'none', fontSize: 13
                    }}
                  >
                    📄 View ID Document
                  </a>
                </div>
              )}

              {selectedHelper.selfie_url && (
                <div style={{ marginBottom: 12 }}>
                  <p style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Selfie Verification</p>
                  <a
                    href={selectedHelper.selfie_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: 8,
                      padding: '8px 12px', background: '#f0f0f0', borderRadius: 6,
                      color: '#0066cc', textDecoration: 'none', fontSize: 13
                    }}
                  >
                    📷 View Selfie
                  </a>
                </div>
              )}

              {!selectedHelper.id_document_url && !selectedHelper.selfie_url && (
                <div style={{ padding: 20, background: '#fff3cd', borderRadius: 8, textAlign: 'center' }}>
                  <p style={{ margin: 0, color: '#856404', fontSize: 13 }}>
                    No verification documents submitted yet
                  </p>
                </div>
              )}
            </div>

            {/* Profile Info */}
            <div style={{ marginBottom: 24 }}>
              <h4 style={{ margin: '0 0 12px 0', fontSize: 14, fontWeight: 600 }}>Profile Information</h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <p style={{ fontSize: 12, color: '#666', marginBottom: 2 }}>Experience</p>
                  <p style={{ fontSize: 14, margin: 0 }}>{selectedHelper.experience_years || 0} years</p>
                </div>
                <div>
                  <p style={{ fontSize: 12, color: '#666', marginBottom: 2 }}>Total Jobs</p>
                  <p style={{ fontSize: 14, margin: 0 }}>{selectedHelper.total_jobs || 0}</p>
                </div>
                <div>
                  <p style={{ fontSize: 12, color: '#666', marginBottom: 2 }}>Rating</p>
                  <p style={{ fontSize: 14, margin: 0 }}>⭐ {selectedHelper.average_rating || 'N/A'}</p>
                </div>
                <div>
                  <p style={{ fontSize: 12, color: '#666', marginBottom: 2 }}>Phone</p>
                  <p style={{ fontSize: 14, margin: 0 }}>{selectedHelper.phone || 'Not provided'}</p>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button
                onClick={() => handleVerify(selectedHelper.id, 'rejected')}
                style={{
                  padding: '12px 24px', background: '#dc3545', color: 'white',
                  border: 'none', borderRadius: 8, fontSize: 14, cursor: 'pointer'
                }}
              >
                Reject
              </button>
              <button
                onClick={() => handleVerify(selectedHelper.id, 'approved')}
                style={{
                  padding: '12px 24px', background: '#28a745', color: 'white',
                  border: 'none', borderRadius: 8, fontSize: 14, cursor: 'pointer'
                }}
              >
                Approve
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Verifications;
